import React, { useState, useEffect } from "react";
import {
  Form,
  DatePicker,
  Radio,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
} from "antd";
import moment from "moment";
import {
  getCompanyUserList,
  getRelevanceCompany,
  exportCompanyUserList,
} from "../../../../api/api";
const { RangePicker } = DatePicker;
const { Option } = Select;

const itemStyle = { width: "300px", marginRight: "15px" };
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const CompanyPersonnel = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [companyCodeList, setcompanyCodeList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });
  useEffect(() => {
    getRelevanceCompanyall();
    getTableData();
  }, []);

  const radioChange = (e) => {
    const startDate = moment()
      .subtract(e.target.value - 1, "days")
      .format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    form.setFieldsValue({
      rangeDate: [moment(startDate), moment(endDate)],
    });
  };
  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({
        rangeDate: null,
      });
    }
  };
  // 获取所有企业
  const getRelevanceCompanyall = async () => {
    const res = await getRelevanceCompany();
    if (res) {
      setcompanyCodeList(res);
    }
  };
  // 分页变化处理
  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
    getTableData({
      pageNum: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };
  // 获取人员列表
  const getTableData = async (pageParams = {}) => {
    setLoading(true);
    try {
      const { companyCode, keyword, rangeDate } = form.getFieldsValue();
      const params = {
        beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
        endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
        pageNum: pageParams.pageNum || pagination.current,
        pageSize: pageParams.pageSize || pagination.pageSize,
        companyCode: companyCode,
        keyword: keyword,
      };
      const { data: res } = await getCompanyUserList(params);
      if (!res.success) return message.error(res.retMsg);
      setTableData(res.data.list);
      setPagination({
        ...pagination,
        current: pageParams.pageNum || pagination.current,
        pageSize: pageParams.pageSize || pagination.pageSize,
        total: res.data.totalCount,
      });
    } catch (error) {
      message.error("接口请求失败");
    } finally {
      setLoading(false);
    }
  };
  // 查询
  const submit = () => {
    // 查询时重置到第一页
    setPagination({
      ...pagination,
      current: 1,
    });
    getTableData();
  };
  // 导出
  const exportExcel = () => {
    const { companyCode, keyword, rangeDate } = form.getFieldsValue();
    const params = {
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      companyCode: companyCode,
      keyword: keyword,
    };
    exportCompanyUserList(params);
  };
  // 重置
  const resetForm = () => {
    form.resetFields();
  };
  // 列表字段
  const tableColumns = [
    {
      title: "加入时间",
      dataIndex: "createTime",
      key: "createTime",
      width: 180,
      align: "center",
    },
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
      width: 100,
      align: "center",
    },
    {
      title: "手机号",
      dataIndex: "phone",
      key: "phone",
      width: 150,
      align: "center",
    },
    {
      title: "身份证号",
      dataIndex: "idNumber",
      key: "idNumber",
      width: 200,
      align: "center",
    },
    {
      title: "关联公司",
      dataIndex: "companyName",
      key: "companyName",
      width: 200,
      align: "center",
    },
  ];
  return (
    <div>
      <Form form={form} {...labelStyleObj} labelAlign="left">
        <Row>
          <Form.Item label="加入时间" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM-DD"}
              onChange={handlerChange}
            />
          </Form.Item>
          <Form.Item style={{ width: "600px", marginLeft: "15px" }}>
            <Radio.Group onChange={radioChange}>
              <Radio value={1}>今天</Radio>
              <Radio value={7}>近7天</Radio>
              <Radio value={30}>近30天</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label="企业名称" name="companyCode" style={itemStyle}>
            <Select allowClear placeholder="全部">
              {companyCodeList.map((e) => (
                <Option key={e.companyCode} value={e.companyCode}>
                  {e.companyName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="姓名丨身份证号" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default CompanyPersonnel;
